import React from "react";
import "../assets/css/fullLoader.css";
import "../assets/css/loadin.css";

export const Spinner = () => {
  
  return (
    // <div style={{position: "fixed", top: "0%", zIndex: "9999999999", left: "94%"}}>
    //   <Atom color="#0066bf" size="small" text="" textColor="" />
    // </div>
    // <Atom color="#5482ca" size="medium" text="" textColor="" style={{position: "fixed !important", top: "0% !important", zIndex: "9999999999", left: "94%"}}/>
    // <div style={{ zIndex: 99999999999999999999999999999999999999999999999999 }}>
    //   <div id="preloader2" className="text-center">
    //     <img
    //       src={require("../assets/img/loader2.gif")}
    //       className="img-fluid"
    //       alt=""
    //     ></img>
    //   </div>
    // </div>
    
    <div className="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
  
    
  );
};